<template>
 <section class="int-body int-body--solo" data-screen-label="Post-Program">
    <img src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/interior-bg.jpg" alt="" aria-hidden="true" class="int-bg" decoding="async">
    <div class="int-accents" aria-hidden="true">
      <img class="accent accent--md" src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/accent-blimp-medium.png" alt="" decoding="async">
      <img class="accent accent--ticket" src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/accent-golden-ticket.png" alt="" decoding="async">
      <img class="accent accent--sm" src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/accent-blimp-small.png" alt="" decoding="async">
    </div>
    <div class="int-body-inner">
      <div class="solo-lockup">
        <img src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/logo-lockup.png" alt="Kellogg's&reg; Cocoa Loops × Wonka">
      </div>

      <div class="reg-card reg-card--narrow">
        <span class="card-glow" aria-hidden="true"></span>
        <div class="reg-card__head">
          <h3>Thank You For Joining The Journey</h3>
          <p>Receipt submissions for this promotion are now closed.</p>
          <p>Thank you to everyone who participated and helped make this adventure unforgettable.</p>
        </div>

        <div class="center-actions" style="margin-top:30px;">
          <a href="https://www.wkkellogg.com/products/froot-loops-cocoa-loops-cereal" target="_blank" rel="noopener"
            class="btn-gold" style="min-width:240px;padding:15px 26px;">Visit Kellogg's&reg; Cocoa Loops</a>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    startDate: {
      type: Date,
      required: true,
    },
  },
  mounted() {
    // Edge glow (pointer devices; reduced-motion safe)
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const initEdgeGlow = (card) => {
        if (!card) return;
        let glow = 0, targetGlow = 0, angle = 0, targetAngle = 0, raf = null;
        const THRESH = 0.60;
        function onMove(e) {
          const r = card.getBoundingClientRect();
          const cx = r.width / 2, cy = r.height / 2;
          const dx = (e.clientX - r.left) - cx;
          const dy = (e.clientY - r.top) - cy;
          const kx = dx !== 0 ? cx / Math.abs(dx) : Infinity;
          const ky = dy !== 0 ? cy / Math.abs(dy) : Infinity;
          const edge = Math.min(Math.max(1 / Math.min(kx, ky), 0), 1);
          const g = edge < THRESH ? 0 : (edge - THRESH) / (1 - THRESH);
          let deg = Math.atan2(dy, dx) * 180 / Math.PI + 90; if (deg < 0) deg += 360;
          const nc = Math.round((deg - 45) / 90) * 90 + 45;
          const cd = Math.abs(((deg - nc + 540) % 360) - 180);
          const corner = Math.max(0, 1 - cd / 45);
          targetGlow = Math.min(g * (0.82 + 0.34 * corner), 1);
          targetAngle = deg;
          start();
        }
        function onLeave() { targetGlow = 0; start(); }
        function start() { if (!raf) raf = requestAnimationFrame(step); }
        function step() {
          glow += (targetGlow - glow) * 0.10;
          const d = ((targetAngle - angle + 540) % 360) - 180;
          angle = (angle + d * 0.14 + 360) % 360;
          card.style.setProperty('--hglow', glow.toFixed(3));
          card.style.setProperty('--hangle', angle.toFixed(1) + 'deg');
          if (Math.abs(targetGlow - glow) > 0.002 || Math.abs(d) > 0.4) raf = requestAnimationFrame(step);
          else raf = null;
        }
        card.addEventListener('pointermove', onMove);
        card.addEventListener('pointerleave', onLeave);
        return () => { card.removeEventListener('pointermove', onMove); card.removeEventListener('pointerleave', onLeave); if (raf) cancelAnimationFrame(raf); };
      };

      // init on elements present now
      this._edgeGlowCleanups = [];
      document.querySelectorAll('.reg-card, .up-panel').forEach((el) => {
        const c = initEdgeGlow(el);
        if (typeof c === 'function') this._edgeGlowCleanups.push(c);
      });
    }

    // Toucan placement: position `.verify-toucan` at top-right of `.reg-card` when present
    const placeToucan = () => {
      const t = document.querySelector('.verify-toucan');
      const card = document.querySelector('.reg-card');
      if (!t || !card) return;
      const r = card.getBoundingClientRect();
      t.style.top = (r.top + window.scrollY - (t.offsetHeight - 50)) + 'px';
      t.style.left = (r.right + window.scrollX - t.offsetWidth + 2) + 'px';
    };

    const onResize = () => placeToucan();
    const onLoad = () => placeToucan();
    window.addEventListener('resize', onResize);
    window.addEventListener('load', onLoad);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeToucan);
    const toucanImg = document.querySelector('.verify-toucan');
    if (toucanImg && !toucanImg.complete) toucanImg.addEventListener('load', placeToucan);

    this._preprogramCleanup = () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('load', onLoad);
      if (toucanImg && !toucanImg.complete) toucanImg.removeEventListener('load', placeToucan);
      if (Array.isArray(this._edgeGlowCleanups)) { this._edgeGlowCleanups.forEach(fn => fn()); this._edgeGlowCleanups = null; }
    };
  },
  beforeUnmount() {
    if (typeof this._preprogramCleanup === 'function') this._preprogramCleanup();
  }
};
</script>
<style scoped></style>
